"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CONTENT : STYLES --------------- ++++++++++ */


var _default = {
  content: {
    padding: (0, _index.replacePXinStringWithEM)("26px ".concat(_index.theme.spacing.sides, " 100px")),
    minHeight: (0, _index.pxToEm)(500)
  }
};
exports.default = _default;